import React from "react";
import { ReactSVG } from "react-svg";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import { useInView } from "react-intersection-observer";
import { useDownload } from "./DownloadContext";

const CTASection = () => {
  const { ref: ctaRef, inView: ctaView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const { startDownload } = useDownload();
  return (
    <section className="w-full max-w-[1180px] mx-auto md:px-7 px-4">
      <div
        ref={ctaRef}
        className={`${ctaView ? "animate-scaleIn z-[3] anim-preserve" : "opacity-0 z-0"
          } relative overflow-hidden rounded-3xl border border-[#3AB1F626] px-6 sm:px-10 py-12 sm:py-14 flex flex-col items-center gap-5`}
        style={{
          background:
            "linear-gradient(180deg, #EBF7FE 0%, #F6FBFE 100%)",
        }}
      >
        <h2 className="font-jakarta font-extrabold text-[#0F1B2D] text-center text-[2.625rem] md:text-[2.4rem] lg:text-[2.8rem] xl:text-[3.125rem] leading-[1.24] tracking-[-0.02em]">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
            Stop Typing
          </span>{" "}
          on Windows. Speak once. Done.
        </h2>
        <p className="font-inter font-normal text-[#33425A] text-center text-[1.313rem] md:text-[1.15rem] lg:text-[1.2rem] xl:text-[1.438rem] leading-[1.5] max-w-[680px]">
          Your voice is faster than your keyboard. Put it to work across every
          Windows app today.
        </p>

        <div className="flex sm:flex-row flex-col items-center gap-3 mt-1">
          <button
            type="button"
            onClick={() => startDownload()}
            style={{
              background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
            }}
            className="hover:opacity-90 transition-opacity duration-300 text-white rounded-full flex items-center gap-2 px-6 py-3 font-inter font-semibold text-base shadow-md"
          >
            <ReactSVG
              src={microsoftIcon}
              beforeInjection={(svg) => {
                svg.setAttribute("class", "w-5 h-5");
              }}
            />
            Download for Windows
          </button>

          {/* <button className="bg-white border border-[#0000001A] hover:bg-gray-50 transition rounded-full flex items-center gap-2 px-6 py-3 font-inter font-semibold text-base text-[#0F1B2D]">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
            Watch the demo
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
